import React, {Component} from 'react';
import PropTypes from "prop-types"
import {Col, Glyphicon, Row} from "react-bootstrap";
import classNames from "classnames";
import {withMediaQuery} from '../../utilities/hooks/useMediaQuery';


const screen32 =  window.innerHeight <= 600;

class InlineEditable extends Component {
    state = {
        edit: false,
        closeEdit: false
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            edit: this.props.service ? !this.props.service?.purchase_order : false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.service?.invoice !== this.props.service?.invoice && this.props.service?.invoice && this.props.length !== 0) {
            this.setState({edit: false});
        }
        if ((prevProps.editMessage !== this.props.editMessage) && this.props.editMessage) {
            this.setState({edit: this.props.editMessage})
        }
        if (this.props.closeEdit != prevProps.closeEdit && this.props.closeEdit === true) {
            this.setState({edit: false})
        }
    }

    handleSubmit = () => {
        if (this.props.length !== 0) {
            this.props.handleSubmit && this.props.handleSubmit();
            this.setState({edit: false})
        }
    };

    render() {
        const {edit} = this.state;
        const {
            value,
            form,
            icons,
            withSubmit,
            editable,
            className,
            color,
            toggleTitleInput,
            fullWidth,
            closeEditable,
            breakWord,
            onClick,
            inputWidth,
            screenWidthL,
            isMobile
        } = this.props;
        let width = withSubmit ? 10 : 12;
        if (fullWidth) {
            width = 12
        }
        return (
            <span className={className}>
                    <Row className={classNames('vcenter', inputWidth)}
                         style={{marginBottom: screen32 && screenWidthL && 0, wordBreak: breakWord && 'break-word'}}>
                        <Col xs={icons ? 6 : width} style={{paddingRight: !isMobile && !fullWidth && 0}}>
                            {!edit && <span className={editable ? 'underline' : ''}
                                            onClick={() => {
                                                editable && this.setState({edit: true}, () => toggleTitleInput && toggleTitleInput(true));
                                                onClick && onClick()
                                            }}>{value}</span>}
                            {edit && form(this.handleSubmit)}
                        </Col>
                        {icons && <Col xs={4} style={{paddingLeft: !isMobile && 0}}>{icons}</Col>}
                        {!fullWidth && withSubmit &&
                            <Col style={{color: color && true && color.includes('#') && color}} xs={1}>
                                {edit && <Glyphicon glyph="ok" className="pointer" onClick={() => {
                                    this.handleSubmit()
                                    toggleTitleInput && toggleTitleInput(false)
                                    closeEditable && closeEditable(false)
                                }}
                                />}
                            </Col>}
                        {fullWidth && edit &&
                            <Col style={{color: color && true && color.includes('#') && color}} xs={1}>
                                <Glyphicon glyph="ok" className="pointer" onClick={() => {
                                    this.handleSubmit()
                                    toggleTitleInput && toggleTitleInput(false)
                                }}
                                />
                            </Col>}
                    </Row>
            </span>
        );
    }
}

InlineEditable.propTypes = {
    form: PropTypes.object,
    value: PropTypes.object,
    icons: PropTypes.object,
    editable: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    withSubmit: PropTypes.bool
};

InlineEditable.defaultProps = {
    editable: true,
    withSubmit: true
};

const InlineEditableWithMedia = withMediaQuery(InlineEditable, {
    screenWidthL: { minWidth: 992 },
    isMobile: { maxWidth: 767 },
});

export default InlineEditableWithMedia;